import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Card,
  Table,
  Button,
  Form,
  Row,
  Col,
  InputGroup,
  Badge,
} from 'react-bootstrap';
import { toast } from 'react-toastify';
import {
  FaSearch,
  FaPlus,
  FaSort,
  FaSortUp,
  FaSortDown,
  FaToggleOn,
  FaChevronRight,
} from 'react-icons/fa';
import Header from '~/Components/Header/Header';
import Loading from '~/Components/Loading';
import history from '~/Config/history';
import * as api from '~/Services/Service';
import AuthStorage from '~/Utils/AuthStorage';
import { caracteristicas } from '~/constant';
import ModalNovoGE from './components/ModalNovoGE';

var GrupoEmpresa = function () {
  var [grupos, setGrupos] = useState([]);
  var [categorias, setCategorias] = useState([]);
  var [loading, setLoading] = useState(true);
  var [loadingAcao, setLoadingAcao] = useState(false);
  var [busca, setBusca] = useState('');
  var [filtroStatus, setFiltroStatus] = useState('');
  var [filtroCategoria, setFiltroCategoria] = useState('');
  var [showModalNovo, setShowModalNovo] = useState(false);
  var [ordenacao, setOrdenacao] = useState({ campo: 'codigo', direcao: 'asc' });

  var debounceRef = useRef(null);

  var temPermissaoStatus = AuthStorage.temCaracteristicas([caracteristicas.AlteraStatusGE]) ||
    AuthStorage.temCaracteristicas([caracteristicas.AlteraStatusGE2]);

  useEffect(function () {
    carregarCategorias();
    carregarGrupos();
  }, []);

  var carregarCategorias = async function () {
    try {
      var res = await api.listarCategoriasGE();
      setCategorias(res || []);
    } catch (e) {
      // silencioso
    }
  };

  var carregarGrupos = async function (params) {
    setLoading(true);
    try {
      var p = params || { busca: busca, status: filtroStatus, categoria: filtroCategoria };
      var res = await api.listarGruposEmpresaAdmin({
        busca: p.busca || undefined,
        status: p.status || undefined,
        categoria: p.categoria || undefined,
      });
      setGrupos(res || []);
    } catch (e) {
      toast.error('Erro ao carregar grupos de empresa');
    } finally {
      setLoading(false);
    }
  };

  var handleBuscaChange = function (e) {
    var valor = e.target.value;
    setBusca(valor);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(function () {
      carregarGrupos({ busca: valor, status: filtroStatus, categoria: filtroCategoria });
    }, 300);
  };

  var handleFiltroChange = function (campo, valor) {
    if (campo === 'status') {
      setFiltroStatus(valor);
      carregarGrupos({ busca: busca, status: valor, categoria: filtroCategoria });
    } else {
      setFiltroCategoria(valor);
      carregarGrupos({ busca: busca, status: filtroStatus, categoria: valor });
    }
  };

  var handleOrdenacao = function (campo) {
    setOrdenacao(function (prev) {
      if (prev.campo === campo) {
        return { campo: campo, direcao: prev.direcao === 'asc' ? 'desc' : 'asc' };
      }
      return { campo: campo, direcao: 'asc' };
    });
  };

  var iconeOrdenacao = function (campo) {
    if (ordenacao.campo !== campo) return <FaSort style={{ opacity: 0.3, marginLeft: 4 }} />;
    return ordenacao.direcao === 'asc'
      ? <FaSortUp style={{ marginLeft: 4 }} />
      : <FaSortDown style={{ marginLeft: 4 }} />;
  };

  var thSortStyle = { cursor: 'pointer', userSelect: 'none' };

  var handleToggleStatus = async function (e, grupo) {
    e.stopPropagation();
    if (!window.confirm('Deseja alterar o status do grupo "' + grupo.apelido + '"?')) return;
    setLoadingAcao(true);
    try {
      var res = await api.toggleStatusGrupoEmpresa(grupo.codigo);
      toast.success('Status alterado com sucesso!');
      setGrupos(function (prev) {
        return prev.map(function (g) {
          if (g.codigo === grupo.codigo) {
            return Object.assign({}, g, { status: res.novo_status });
          }
          return g;
        });
      });
    } catch (err) {
      var msg = (err && err.response && err.response.data && err.response.data.message) || 'Erro ao alterar status';
      toast.error(msg);
    } finally {
      setLoadingAcao(false);
    }
  };

  var handleNovoGECriado = function (codigo) {
    setShowModalNovo(false);
    history.push('/ferramentas/grupo-empresa/' + codigo);
  };

  var gruposOrdenados = (grupos || []).slice().sort(function (a, b) {
    var campo = ordenacao.campo;
    var dir = ordenacao.direcao === 'asc' ? 1 : -1;
    var valA = a[campo];
    var valB = b[campo];
    if (valA == null) valA = '';
    if (valB == null) valB = '';
    if (campo === 'codigo') return dir * (Number(valA) - Number(valB));
    return dir * String(valA).toLowerCase().localeCompare(String(valB).toLowerCase());
  });

  var badgeStatus = function (status) {
    if (status === 'A') return <Badge variant="success">Ativo</Badge>;
    if (status === 'I') return <Badge variant="secondary">Inativo</Badge>;
    if (status === 'C') return <Badge variant="warning">Consulta</Badge>;
    return <Badge variant="light">{status}</Badge>;
  };

  if (loading) return <Loading />;

  return (
    <Container fluid className="px-3 py-3">
      <style>{'\
        .ge-desktop { display: block; }\
        .ge-mobile  { display: none; }\
        @media (max-width: 768px) {\
          .ge-desktop { display: none !important; }\
          .ge-mobile  { display: block; }\
        }\
      '}</style>

      <Header title="Grupo de Empresas" />

      <Card className="shadow-sm mb-3">
        <Card.Body className="py-2">
          <Row className="align-items-center">
            <Col md={4} className="mb-2 mb-md-0">
              <InputGroup size="sm">
                <InputGroup.Prepend>
                  <InputGroup.Text><FaSearch /></InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="text"
                  placeholder="Buscar por código ou apelido..."
                  value={busca}
                  onChange={handleBuscaChange}
                />
              </InputGroup>
            </Col>
            <Col md={2} className="mb-2 mb-md-0">
              <Form.Control
                as="select"
                size="sm"
                value={filtroStatus}
                onChange={function (e) { handleFiltroChange('status', e.target.value); }}
              >
                <option value="">Todos os Status</option>
                <option value="A">Ativo</option>
                <option value="I">Inativo</option>
                <option value="C">Consulta</option>
              </Form.Control>
            </Col>
            <Col md={3} className="mb-2 mb-md-0">
              <Form.Control
                as="select"
                size="sm"
                value={filtroCategoria}
                onChange={function (e) { handleFiltroChange('categoria', e.target.value); }}
              >
                <option value="">Todas as Categorias</option>
                {categorias.map(function (c) {
                  return <option key={c.codigo} value={c.codigo}>{c.descricao}</option>;
                })}
              </Form.Control>
            </Col>
            <Col md={3} className="text-right">
              <Button size="sm" variant="success" onClick={function () { setShowModalNovo(true); }}>
                <FaPlus className="mr-1" /> Novo
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="shadow-sm">
        <Card.Header
          className="d-flex justify-content-between align-items-center py-2"
          style={{ backgroundColor: '#0747a6', color: '#fff' }}
        >
          <strong>
            Grupos de Empresa
            <span className="ml-2" style={{ fontSize: '0.85rem', opacity: 0.8 }}>
              ({gruposOrdenados.length} {gruposOrdenados.length === 1 ? 'registro' : 'registros'})
            </span>
          </strong>
        </Card.Header>
        <Card.Body className="p-0">
          {gruposOrdenados.length === 0 ? (
            <p className="text-muted text-center my-4">
              Nenhum grupo de empresa encontrado.
            </p>
          ) : (
            <>
              {/* Desktop */}
              <div className="ge-desktop">
                <Table striped bordered hover size="sm" className="mb-0">
                  <thead>
                    <tr>
                      <th style={Object.assign({ width: '80px' }, thSortStyle)} onClick={function () { handleOrdenacao('codigo'); }}>
                        Código{iconeOrdenacao('codigo')}
                      </th>
                      <th style={Object.assign({}, thSortStyle)} onClick={function () { handleOrdenacao('apelido'); }}>
                        Apelido{iconeOrdenacao('apelido')}
                      </th>
                      <th style={Object.assign({ width: '200px' }, thSortStyle)} onClick={function () { handleOrdenacao('categoria_descricao'); }}>
                        Categoria{iconeOrdenacao('categoria_descricao')}
                      </th>
                      <th style={{ width: '100px', textAlign: 'center' }}>Status</th>
                      <th style={{ width: '120px', textAlign: 'center' }}>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {gruposOrdenados.map(function (grupo) {
                      return (
                        <tr
                          key={grupo.codigo}
                          style={{ cursor: 'pointer' }}
                          onClick={function () { history.push('/ferramentas/grupo-empresa/' + grupo.codigo); }}
                        >
                          <td>{grupo.codigo}</td>
                          <td style={{ opacity: grupo.status === 'I' ? 0.5 : 1 }}>
                            {grupo.apelido || '-'}
                          </td>
                          <td>{grupo.categoria_descricao || '-'}</td>
                          <td className="text-center">{badgeStatus(grupo.status)}</td>
                          <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                            {temPermissaoStatus && (
                              <Button
                                size="sm"
                                variant="outline-secondary"
                                title="Alternar Status A/I"
                                disabled={loadingAcao}
                                onClick={function (e) { handleToggleStatus(e, grupo); }}
                              >
                                <FaToggleOn />
                              </Button>
                            )}
                            <Button
                              size="sm"
                              variant="outline-primary"
                              className="ml-1"
                              title="Abrir detalhes"
                              onClick={function (e) {
                                e.stopPropagation();
                                history.push('/ferramentas/grupo-empresa/' + grupo.codigo);
                              }}
                            >
                              <FaChevronRight />
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>

              {/* Mobile */}
              <div className="ge-mobile p-2">
                {gruposOrdenados.map(function (grupo) {
                  return (
                    <Card key={grupo.codigo} className="mb-2 shadow-sm">
                      <Card.Body className="py-2 px-3">
                        <div className="d-flex justify-content-between align-items-start">
                          <div>
                            <strong>{grupo.apelido || '(sem apelido)'}</strong>
                            <br />
                            <small className="text-muted">
                              Código: {grupo.codigo} | {grupo.categoria_descricao || '-'}
                            </small>
                          </div>
                          <div>{badgeStatus(grupo.status)}</div>
                        </div>
                        <div className="mt-2 d-flex" style={{ gap: '8px' }}>
                          <Button
                            size="sm"
                            variant="primary"
                            onClick={function () { history.push('/ferramentas/grupo-empresa/' + grupo.codigo); }}
                          >
                            Detalhes
                          </Button>
                          {temPermissaoStatus && (
                            <Button
                              size="sm"
                              variant="outline-secondary"
                              disabled={loadingAcao}
                              onClick={function (e) { handleToggleStatus(e, grupo); }}
                            >
                              Alternar Status
                            </Button>
                          )}
                        </div>
                      </Card.Body>
                    </Card>
                  );
                })}
              </div>
            </>
          )}
        </Card.Body>
      </Card>

      <ModalNovoGE
        show={showModalNovo}
        onHide={function () { setShowModalNovo(false); }}
        onCriado={handleNovoGECriado}
      />
    </Container>
  );
};

export default GrupoEmpresa;
